const config = {
  baseApiURL: `${process.env.REACT_APP_BASE_API_URL}`,
  defaultTimeout: 1000 * 60 * 10,
  defaultTokenExpires: 365,
}

export const ADMIN_PATH_AFTER_LOGIN = '/admin/dashboard/project'
export default config
